/**
 * language-switcher.js — dropdown chọn ngôn ngữ trên utility topbar.
 *
 * Việc dịch do plugin GTranslate lo: mỗi <a> trong danh sách mang `data-gt-lang`,
 * base.js của plugin tự gắn href + bắt sự kiện click. Script này chỉ làm 2 việc:
 *   1. đóng/mở dropdown;
 *   2. đánh dấu ngôn ngữ đang xem (class .current-lang + nhãn 2 chữ trên nút).
 *
 * Vì sao đọc cookie chứ không dùng class .gt-current-lang mà base.js gắn: base.js nạp
 * ở footer SAU file này, lúc đây chạy thì class đó chưa tồn tại. Cookie `googtrans`
 * chính là thứ base.js đọc, nên hai bên không thể lệch nhau.
 *
 * Bản tĩnh không có plugin ⇒ không có cookie ⇒ giữ nguyên ngôn ngữ đầu danh sách.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var switcher = document.querySelector('.language-switcher');
    if (!switcher) return;

    var toggle = switcher.querySelector('[data-dropdown-toggle]');

    function setOpen(open) {
        switcher.classList.toggle('is-open', open);
        if (toggle) {
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
    }

    if (toggle) {
        toggle.addEventListener('click', function (event) {
            event.stopPropagation();
            setOpen(!switcher.classList.contains('is-open'));
        });
    }

    document.addEventListener('click', function (event) {
        if (!switcher.contains(event.target)) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') setOpen(false);
    });

    switcher.addEventListener('focusout', function (event) {
        if (!switcher.contains(event.relatedTarget)) setOpen(false);
    });

    // ----- Ngôn ngữ đang xem -----
    // Cookie dạng "/en/ja" (nguồn/đích) hoặc "/auto/zh-CN"; phần cuối là ngôn ngữ đang xem.
    function currentLang() {
        var match = document.cookie.match(/(?:^|;\s*)googtrans=([^;]*)/);
        if (!match) return '';

        var parts = decodeURIComponent(match[1]).split('/');

        return parts[parts.length - 1] || '';
    }

    var items = [].slice.call(switcher.querySelectorAll('.lang-item'));
    if (!items.length) return;

    var label = switcher.querySelector('[data-lang-current]');

    // Đánh dấu một ngôn ngữ là đang xem: tick trong dropdown + 2 chữ trên nút.
    function markCurrent(link) {
        if (!link) return;

        items.forEach(function (item) {
            item.classList.toggle('current-lang', item.contains(link));
        });

        if (label && link.getAttribute('data-lang')) {
            label.textContent = link.getAttribute('data-lang');
        }
    }

    function linkFor(code) {
        return code ? switcher.querySelector('[data-gt-lang="' + code + '"]') : null;
    }

    /*
     * Cập nhật NGAY khi bấm, không đợi tải lại trang.
     *
     * base.js của GTranslate gọi evt.preventDefault() rồi dịch tại chỗ bằng widget của
     * Google — trang không hề tải lại. Nếu chỉ đọc cookie lúc khởi động thì tick và nhãn
     * đứng nguyên ở ngôn ngữ cũ cho tới lần chuyển trang sau.
     *
     * KHÔNG preventDefault ở đây: việc đó là của base.js, chặn thêm một lần nữa không đổi
     * gì nhưng làm hỏng bản tĩnh (href="#" sẽ nhảy lên đầu trang).
     */
    items.forEach(function (item) {
        var link = item.querySelector('[data-gt-lang]');
        if (!link) return;

        link.addEventListener('click', function (event) {
            // Bản tĩnh không có GTranslate nên href vẫn là "#" — base.js gắn class
            // .glink cho những thẻ nó đã tiếp quản. Không có class đó thì tự chặn,
            // nếu không bấm một cái là trang nhảy về đầu.
            if (!link.classList.contains('glink')) {
                event.preventDefault();
            }

            markCurrent(link);
            setOpen(false);
        });
    });

    // Lúc tải trang: ngôn ngữ đang xem lấy từ cookie. Không có cookie (lần đầu vào,
    // hoặc cookie trỏ tới ngôn ngữ đã gỡ khỏi danh sách) thì giữ mục đầu tiên —
    // đúng thứ PHP đã in sẵn ra nút.
    markCurrent(linkFor(currentLang()) || items[0].querySelector('[data-gt-lang]'));
})();
